export enum LabelsTypes {
  none = '',
  subscription = 'subscription',
}

export const LabelTitles: Record<LabelsTypes, string> = {
  [LabelsTypes.none]: 'none',
  [LabelsTypes.subscription]: 'Бонусы подписки',
} as const;

export interface Label {
  id: number;
  type: LabelsTypes;
  info: string[];
}

export type LabelForm = Omit<Label, 'id' | 'type'>;
